import { useTranslation } from 'react-i18next';
import { Skeleton } from 'antd';
import { useGetOverdueAggregatedStatistics } from 'api/statistic/use-get-overdue-aggregated-statistics';
import { useGetOverdueStatistics } from 'api/statistic/use-get-overdue-statistics';
import { useOverdueFiltersStore } from 'shared/stores/use-overdue-filters';
import { LinearChart } from 'components/insights/linear-chart';
import { OverdueTotals } from 'components/statistics/overdue-totals';
import styles from './overdue-section.module.scss';

export const OverdueSection = () => {
  const { t } = useTranslation();
  const { filters } = useOverdueFiltersStore();
  const { data, isFetching: isStatisticsFetching } = useGetOverdueStatistics({ filters });
  const { data: totals, isFetching: isTotalsFetching } = useGetOverdueAggregatedStatistics({ filters });

  const sectionTitle = t(`cargo:${filters.type}`);

  const countSeries = [
    { name: t('overdue:total_cargos'), data: data?.series.totalCount ?? [] },
    { name: t('overdue:overdue_cargos'), data: data?.series.overdueCount ?? [] },
    { name: t('overdue:not_delivered_cargos'), data: data?.series.unfinishedCount ?? [] },
  ];

  const delaySeries = [{ name: t('overdue:total_delay'), data: data?.series.overdueTotalDelay ?? [], unit: 'days' }];
  const isFetching = isStatisticsFetching || isTotalsFetching;
  const isDataExists = data && totals;

  return (
    <section className={styles.section}>
      <Skeleton loading={isFetching}>
        {isDataExists && (
          <>
            <OverdueTotals totals={totals} />
            <div className={styles.charts}>
              <LinearChart
                title={t('overdue:overdue_chart_title', { section: sectionTitle })}
                mainSeries={countSeries}
              />
              <LinearChart
                title={t('overdue:total_delay_chart_title', { section: sectionTitle })}
                mainSeries={delaySeries}
              />
            </div>
          </>
        )}
      </Skeleton>
    </section>
  );
};
